import { Select, Option } from 'element-ui'
import ResourceSvc from '@/services/resource.svc.js';
import store from '@/services/store.js';

const svc = new ResourceSvc();

export default {
    props: ['status'],
    name: 'AdminCourseTypeSelect',
    components: {
        [Select.name]: Select,
        [Option.name]: Option
    },
    data() {
        return {
            selects: {
                simple: '',
                types: []
            },
        }
    },
    methods: {
        changeType(val) {
            this.$parent.$parent.$data.typeId = val;
            this.$parent.$parent.$data.currentTypeId = val;
        },
        reload() {
            var that = this;
            svc.getCourseTypes().then(response => {
                that.selects.types = response.body;
                if (that.selects.types.length) {
                    that.selects.simple = response.body[0].id;
                    store.commit('setCourseTypes', JSON.parse(JSON.stringify(response.body)));
                }
            }, response => {
                //todo add interseptor
            });
        }
    },
    created() {
        this.reload();
    }
}



// WEBPACK FOOTER //
// ./src/components/admin/courses/course-type-select/course-type-select.js